module.exports = __webpack_public_path__ + "images/pdkzhuanjin.png?27e55263f18cbed095bf47761f04811a";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdkzhuanjin.png
// module id = 224
// module chunks = 1